import { useMemo } from 'react'

import { MultiSelect, SimpleGrid } from '@mantine/core'
import { useGetList, useTranslate } from 'react-admin'
import { BeneficiaryApiDTO } from '../../codegen/generated/Api.schemas'
import { SourceHelper } from '../../helpers/Source.helper'
import { UsersHelper } from '../../helpers/Users.helper'
import { UserScopesStructure } from '../../types/UserScopes'

type UserScopesItemProps = {
  scopesItems: UserScopesStructure
  onUpdate: (userScopes: UserScopesStructure) => void
}

export const UserScopesItem = ({ scopesItems, onUpdate }: UserScopesItemProps) => {
  const t = useTranslate()

  const beneficiariesQuery = useGetList<BeneficiaryApiDTO>(
    'beneficiaries',
    {
      sort: { field: 'name', order: 'ASC' },
      pagination: { page: 1, perPage: 10000 },
      filter: {
        cms: scopesItems.cms,
      },
    },
    {
      enabled: !!scopesItems.cms && scopesItems.cms.length > 0,
    },
  )
  const beneficiaries = useMemo(
    () =>
      (beneficiariesQuery.data ?? []).map(b => ({
        value: b.id,
        label: b.name,
      })),
    [beneficiariesQuery.data],
  )

  const youtubeChannelsQuery = useGetList<BeneficiaryApiDTO>(
    'youtubeChannels',
    {
      sort: { field: 'name', order: 'ASC' },
      pagination: { page: 1, perPage: 10000 },
      filter: {
        cms: scopesItems.cms.flatMap(c => SourceHelper.cmsToYoutubeChannelCms(c)),
      },
    },
    {
      enabled: !!scopesItems.cms && scopesItems.cms.length > 0,
    },
  )
  const youtubeChannels = useMemo(
    () =>
      (youtubeChannelsQuery.data ?? []).map(b => ({
        value: b.id,
        label: b.name,
      })),
    [youtubeChannelsQuery.data],
  )

  return (
    <SimpleGrid cols={3} spacing="sm" mb="xs">
      <MultiSelect
        data={UsersHelper.CMS}
        placeholder={scopesItems.cms.length === 0 ? t('_generics.all_male') : ''}
        value={scopesItems.cms}
        onChange={ids => {
          onUpdate({
            ...scopesItems,
            cms: ids,
            beneficiariesIds: [],
            youtubeChannelsIds: [],
          })
        }}
        flex="1"
      />
      <MultiSelect
        data={beneficiaries}
        placeholder={scopesItems.beneficiariesIds.length === 0 ? t('_generics.all_male') : ''}
        value={scopesItems.beneficiariesIds}
        onChange={beneficiariesIds => {
          onUpdate({
            ...scopesItems,
            beneficiariesIds,
          })
        }}
        disabled={beneficiaries.length === 0}
        flex="1"
      />
      <MultiSelect
        data={youtubeChannels}
        placeholder={scopesItems.youtubeChannelsIds.length === 0 ? t('_generics.all_female') : ''}
        value={scopesItems.youtubeChannelsIds}
        onChange={youtubeChannelsIds => {
          onUpdate({
            ...scopesItems,
            youtubeChannelsIds,
          })
        }}
        disabled={youtubeChannels.length === 0}
        flex="1"
      />
    </SimpleGrid>
  )
}
